theme.headerSticky = (function() {
  function ScrollSticky(e){
    const headerStickyWrapper = document.querySelector('header');
    const headerStickyTarget = document.querySelector('.header__sticky');

    if (headerStickyTarget) {
      // Reserve the header's space in the document flow at all times so
      // nothing below it shifts when the bar goes position:fixed.
      function reserveHeaderSpace() {
        var h = headerStickyTarget.getBoundingClientRect().height;
        headerStickyWrapper.style.minHeight = h + 'px';
      }

      // Set on load and whenever the viewport resizes (orientation change etc.)
      reserveHeaderSpace();
      window.addEventListener('resize', reserveHeaderSpace);

      var headerHeight = headerStickyWrapper.offsetHeight;

      window.addEventListener('scroll', function () {
        if (window.scrollY > headerHeight) {
          headerStickyTarget.classList.add('sticky');
        } else {
          headerStickyTarget.classList.remove('sticky');
        }
      }, { passive: true });
    }
  }
  return ScrollSticky;
})();


